module.exports = __webpack_public_path__ + "static/logo-stripe.4a33ef34.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo-stripe.png
// module id = 606
// module chunks = 231608221292675